function onFooter() {
  const windowWidth = jQuery(window).width();
  jQuery('.widget-title').off('click keypress');

  jQuery('.footer-menu div').attr('aria-hidden', windowWidth <= 992 ? 'true' : 'false');

  if (windowWidth <= 992) {
    jQuery('.footer-menu div').hide();
    jQuery('.widget-title')
      .attr('tabindex', '0')
      .attr('role', 'button')
      .attr('aria-expanded', 'false')
      .on('click keypress', function (e) {
        if (e.type === 'click' || e.key === 'Enter') {
          const isActive = jQuery(this).hasClass('active');
          jQuery(this).toggleClass('active', !isActive).attr('aria-expanded', !isActive);
          jQuery('.widget-title').not(jQuery(this)).removeClass('active').attr('aria-expanded', 'false');
          jQuery('.footer-menu div').not(jQuery(this).next()).slideUp(500).attr('aria-hidden', 'true');

          const panel = jQuery(this).next('.footer-menu div');
          panel.slideToggle(500).attr('aria-hidden', panel.is(':visible').toString());
        }
      });
  } else {
    jQuery('.footer-menu div').show().attr('aria-hidden', 'false');
    jQuery('.widget-title').removeClass('active').removeAttr('tabindex').removeAttr('role').removeAttr('aria-expanded');
  }
}

let debounce;
jQuery(window).resize(function () {
  clearTimeout(debounce);
  debounce = setTimeout(function () {
    jQuery('.widget-title.active').each(function () {
      jQuery(this).removeClass('active').attr('aria-expanded', 'false');
      jQuery(this).next('.footer-menu div').slideUp(500).attr('aria-hidden', 'true');
    });
    onFooter();
  }, 10);
});

export default onFooter;

